import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=669f5b32&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=669f5b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f5b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('669f5b32')) {
      api.createRecord('669f5b32', component.options)
    } else {
      api.reload('669f5b32', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=669f5b32&scoped=true&", function () {
      api.rerender('669f5b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/Documents.vue"
export default component.exports